var SpeechControls = require("components/writing/questions/SpeechControls");

require("writing/questions/fill_in_the_blank.scss")

class FillInTheBlank extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	onChange(index, e) {
		var newParts = _.clone(this.props.answerParts);
		newParts[index] = _.extend({}, this.props.answerParts[index], {
			text: e.target.value
		});
		this.props.onChange(newParts)
	}

	getAnswer() {
		return _.findWhere(this.props.answerParts, { type: BODY }).text
	}
	getTextToRead() {
		var starterParts = _.where(this.props.answerParts, { type: STARTER });
		return _.pluck(starterParts, "text").join(" ... ... ... ");
	}
	setVoiceText(text) {
		var firstBodyIndex = _.findIndex(this.props.answerParts, x => x.type == BODY);
		this.onChange(firstBodyIndex, { target: { value: text } });
	}

	renderSpeechControls() {
		if (this.props.speechControlSetting != "off") {
			return (
				<div className="voiceFirstSpeechControls">
					<SpeechControls getText={ this.getAnswer } setText={ this.setVoiceText }
						getTextToRead={ this.getTextToRead }
						autoReadText={ this.props.speechControlSetting == "voice-first" } />
				</div>
			);
		}
	}

	render() {
		var index = 0;
		var textareas = [];

		var elements = [];
		_.each(this.props.answerParts, (part, index) => {
			if (part.type == STARTER) {
				elements.push(
					<span className="text" key={ "starter-" + index }>{ part.text }</span>
				);
			} else {
				elements.push(
					<input className="form-control"
						onChange={ this.onChange.bind(this, index) }
						key={ "input-" + index } value={ part.text } 
						onPaste={this.props.handlePasteBehaviour}/>
				);
			}
		});

		return (
			<div className="fillInTheBlank">
				<div>
					{ elements }
				</div>
				{ this.renderSpeechControls() }

			</div>
		)
	}
}

FillInTheBlank.initialAnswerParts = (starterOps, seed) => {
	var randIndex = $wr.psuedoRandom(seed, starterOps.length);
	return _.flatten(_.map(starterOps[randIndex], (starterText) => {
		return [
			{ type: STARTER, text: starterText },
			{ type: BODY, text: "" }
		];
	}));
}

var STARTER = "starter";
var BODY = "body";

FillInTheBlank.BODY = BODY;
FillInTheBlank.STARTER = STARTER;

FillInTheBlank.propTypes = StrictPropTypes({
	answerParts: PropTypes.array.isRequired,
	onChange: PropTypes.func.isRequired,
	maxLength: PropTypes.number,
	handlePasteBehaviour: PropTypes.func,
	speechControlSetting: PropTypes.string
});

module.exports = FillInTheBlank;



// WEBPACK FOOTER //
// ./modules/components/writing/questions/FillInTheBlank.js